module.exports = __webpack_public_path__ + "static/media/p002.0a6d3886.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/p002.jpg
// module id = 1515
// module chunks = 0